/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Seat_Price_Free_MinimumInputs */



/**
* | output |
* | --- |
* | "You already pay for an empty {type} seat, so nothing is charged." |
*
* @param {Seat_Price_Free_MinimumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_free_minimum = /** @type {((inputs: Seat_Price_Free_MinimumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Free_MinimumInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie bezahlen bereits einen freien ${i?.type}-Platz, daher wird nichts berechnet.`)
	return /** @type {LocalizedString} */ (`You already pay for an empty ${i?.type} seat, so nothing is charged.`)
});